module.exports = __webpack_public_path__ + "static/media/59.d3d5604f.jpg";